import { Route, Routes } from "react-router-dom";

import { withRouter } from "../utils";

import ConnectWallet from "../components/ConnectWallet";
import Form from "../pages/form";

const AppRoutes = () => {
  return (
    <>
      <ConnectWallet />

      <>
        <Routes>
          <Route path={"/"} element={<Form />} />
        </Routes>
      </>
    </>
  );
};

export default withRouter(AppRoutes);
